import styled from 'styled-components';
import { ClearButton } from '#/shared/components/Styled';
import { DESKTOP_MIN_BREAK, GTM_DATA_ATTRIBUTE } from '#/shared/constants';
import GTM_HANDLES from '#/shared/gtm-handles';

export const AlertListBody = styled.div`
  display: flex;
  flex-direction: column;
  max-width: ${DESKTOP_MIN_BREAK};
  margin-bottom: 5px;
  padding: 0 8px;
`;

export const RouteRow = styled(ClearButton).attrs({
  [GTM_DATA_ATTRIBUTE]: GTM_HANDLES.alertsList.routeButton,
})`
  display: flex;
  flex: 1 1 auto;
  width: 100%;
  padding-right: 8px;
  user-select: none;
  background-color: ${props => props.theme.secondaryBackgroundColor};
  border: 1px solid ${props => props.theme.tertiaryColor};
  border-radius: 5px;
  min-height: 50px;
  align-items: center;
  font-size: 1em;
  margin: 2px 0;
  transition: ${props => props.theme.boxShadowTransition};
  @media (any-hover: hover) {
    &:hover {
      background-color: ${props => props.theme.secondaryBackgroundColor};
      transition: ${props => props.theme.boxShadowTransition};
      box-shadow: ${props => props.theme.boxShadowCardHover};
    }
  }
  &:focus,
  &:active {
    background-color: ${props => props.theme.secondaryBackgroundColor};
  }

  /* prevents focus indicators from being cut off at the top */
  &:first-child {
    margin-top: 5px;
  }
`;

export const RouteDetailsColumn = styled.div`
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  overflow: hidden;
`;

export const RouteBadgeColumn = styled.div`
  flex: 0 1 30px;
  margin-left: 8px;
`;

export const RouteNameColumn = styled.div`
  flex: 1 1 auto;
  margin: 0 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
`;

export const AlertCountColumn = styled.div`
  flex: 0 0 45px;
  display: flex;
  justify-content: center;
`;
